import { render, staticRenderFns } from "./biyeAuditCw.vue?vue&type=template&id=4b48c7b9&scoped=true"
import script from "./biyeAuditCw.vue?vue&type=script&lang=js"
export * from "./biyeAuditCw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48c7b9",
  null
  
)

export default component.exports